import { useMemo, useCallback } from "react";
import { useQueryParams, StringParam, NumberParam } from "routing/QueryParams";
const CLEAN_URL_PARAMS = {
  from: void 0,
  to: void 0,
  keyword: void 0,
  rangetype: void 0,
  range: void 0,
  streams: void 0,
  fields: void 0,
  dataLakeId: void 0
};
const parseNestedObject = (fieldQueryString) => {
  try {
    return JSON.parse(decodeURIComponent(fieldQueryString));
  } catch (_error) {
    return null;
  }
};
const NestedObjectParam = {
  encode: (object) => object ? encodeURIComponent(JSON.stringify(object)) : void 0,
  decode: (objectStr) => parseNestedObject(objectStr)
};
const QUERY_PARAM_CONFIG_MAP = {
  rangetype: StringParam,
  from: StringParam,
  to: StringParam,
  range: NumberParam,
  streams: StringParam,
  keyword: StringParam,
  relative: NumberParam,
  q: StringParam,
  fields: NestedObjectParam,
  dataLakeId: StringParam
};
const initialTimeRange = (queryParams) => {
  switch (queryParams.rangetype) {
    case "relative":
      if (queryParams.relative !== void 0) {
        return {
          type: queryParams.rangetype,
          range: queryParams.relative
        };
      }
      return {
        type: queryParams.rangetype,
        from: queryParams.from ? Number(queryParams.from) : void 0,
        to: queryParams.to ? Number(queryParams.to) : void 0
      };
    case "absolute":
      return {
        type: queryParams.rangetype,
        from: queryParams.from,
        to: queryParams.to
      };
    case "keyword":
      return {
        type: queryParams.rangetype,
        keyword: queryParams.keyword
      };
    default:
      return void 0;
  }
};
const useUrlParams = () => {
  var _a;
  const [query, setQuery] = useQueryParams(QUERY_PARAM_CONFIG_MAP);
  const queryStream = (_a = query.streams) == null ? void 0 : _a.split(",")[0];
  const urlParams = useMemo(
    () => ({
      timerange: initialTimeRange(query),
      stream: queryStream,
      fields: query.fields,
      dataLakeId: query.dataLakeId
    }),
    [query, queryStream]
  );
  const initialUrlParams = useMemo(() => urlParams, []);
  const resetUrlQueryParams = useCallback(() => {
    setQuery((cur) => ({
      ...CLEAN_URL_PARAMS,
      dataLakeId: cur.dataLakeId
    }));
  }, [setQuery]);
  const setDataLakeIdUrlParam = useCallback(
    (dataLakeId, resetOtherParams = false) => setQuery((cur) => {
      if (resetOtherParams) {
        return {
          ...CLEAN_URL_PARAMS,
          dataLakeId
        };
      }
      return {
        ...cur,
        dataLakeId
      };
    }),
    [setQuery]
  );
  return {
    initialUrlParams,
    urlParams,
    resetUrlQueryParams,
    setDataLakeIdUrlParam
  };
};
export default useUrlParams;
